define.alias("shared/components/shared/ember-drop-multi-select", "settings/components/shared/ember-drop-multi-select");